module.exports = __webpack_public_path__ + "img/milky-way-illustration-1169754.bbf4beea.jpg";